import {
  POST_LETTER_AUTO_GENERATE_GENERATE_REQUEST,
  POST_LETTER_AUTO_GENERATE_GENERATE_SUCCESS,
  POST_LETTER_AUTO_GENERATE_GENERATE_FAILURE,
} from '../../constants/ActionTypes'

import { LetterAutoGenerateApi } from '../api/LetterAutoGenerateApi';

/*** POST /letter-auto-generate/generate ***/
const postGenerateRequest = () => ({
  type: POST_LETTER_AUTO_GENERATE_GENERATE_REQUEST,
});

const postGenerateSuccess = (data) => ({
  type: POST_LETTER_AUTO_GENERATE_GENERATE_SUCCESS,
  payload: {
    data: data
  }
});

const postGenerateFailure = (error) => ({
  type: POST_LETTER_AUTO_GENERATE_GENERATE_FAILURE,
  payload: {
    error: error
  }
});

export function postGenerate(data) {
  return async (dispatch) => {
    dispatch(postGenerateRequest());

    LetterAutoGenerateApi.postGenerate(data, dispatch)
      .then((response) => {
        dispatch(postGenerateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(postGenerateFailure(error.response));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/LetterAutoGenerate.js